import { z } from 'zod';
export const UserNotificationResourceType = ['meeting_body_vacancies'];
export const userNotificationCreateSchema = z.object({
    governmentId: z.number('Government ID is required').int(),
    resourceId: z.number('Resource ID is required').int(),
    resourceType: z.enum(UserNotificationResourceType),
});
export const userNotificationQuerySchema = z.object({
    resourceType: z.enum(UserNotificationResourceType),
});
export const userNotificationWithGovernmentQuerySchema = z.object({
    resourceType: z.enum(UserNotificationResourceType),
    governmentId: z.coerce.number().int(),
});
